import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AddressSelector from './shared/AddressSelector';
import { TitleField } from '../OrderForm/OrderForm';

const AddressField = ({ formData, onChange, uiSchema, errorSchema, disabled, required, schema }) => {
  const addressData = formData || {};
  const titleKey = uiSchema?.['ui:title'] || schema?.title || 'address';

  const isNested = uiSchema?.['ui:options']?.nested;
  const showLabel = uiSchema?.['ui:options']?.label !== false;

  return (
    <div className="flex flex-col">
      {showLabel && (
        <TitleField title={titleKey} required={required} skipCheck />
      )}

      <div className={`w-full ${showLabel ? 'pl-2 sm:pl-4 md:pl-5' : ''}`}>
        <AddressSelector
          addressData={addressData}
          onChange={onChange}
          disabled={disabled}
          errors={errorSchema}
          required={required}
          schema={schema}
        />
      </div>
    </div>
  );
};

AddressField.propTypes = {
  formData: PropTypes.object,
  onChange: PropTypes.func,
  uiSchema: PropTypes.object,
  errorSchema: PropTypes.object,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  schema: PropTypes.object,
};

export default AddressField;
